"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIssueTypeScreenSchemesOrderByEnum = exports.IssueTypeScreenSchemesApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class IssueTypeScreenSchemesApi extends runtime.BaseAPI {
    /**
     * Appends issue type to screen scheme mappings to an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Append mappings to issue type screen scheme
     */
    appendMappingsForIssueTypeScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeId'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeId', 'Required parameter "issueTypeScreenSchemeId" was null or undefined when calling appendMappingsForIssueTypeScreenScheme().');
            }
            if (requestParameters['issueTypeScreenSchemeMappingDetails'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeMappingDetails', 'Required parameter "issueTypeScreenSchemeMappingDetails" was null or undefined when calling appendMappingsForIssueTypeScreenScheme().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/{issueTypeScreenSchemeId}/mapping`.replace(`{${"issueTypeScreenSchemeId"}}`, encodeURIComponent(String(requestParameters['issueTypeScreenSchemeId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.IssueTypeScreenSchemeMappingDetailsToJSON)(requestParameters['issueTypeScreenSchemeMappingDetails']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Appends issue type to screen scheme mappings to an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Append mappings to issue type screen scheme
     */
    appendMappingsForIssueTypeScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.appendMappingsForIssueTypeScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Assigns an issue type screen scheme to a project.  Issue type screen schemes can only be assigned to classic projects.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Assign issue type screen scheme to project
     */
    assignIssueTypeScreenSchemeToProjectRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeProjectAssociation'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeProjectAssociation', 'Required parameter "issueTypeScreenSchemeProjectAssociation" was null or undefined when calling assignIssueTypeScreenSchemeToProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/project`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.IssueTypeScreenSchemeProjectAssociationToJSON)(requestParameters['issueTypeScreenSchemeProjectAssociation']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Assigns an issue type screen scheme to a project.  Issue type screen schemes can only be assigned to classic projects.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Assign issue type screen scheme to project
     */
    assignIssueTypeScreenSchemeToProject(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.assignIssueTypeScreenSchemeToProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create issue type screen scheme
     */
    createIssueTypeScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeDetails'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeDetails', 'Required parameter "issueTypeScreenSchemeDetails" was null or undefined when calling createIssueTypeScreenScheme().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.IssueTypeScreenSchemeDetailsToJSON)(requestParameters['issueTypeScreenSchemeDetails']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.IssueTypeScreenSchemeIdFromJSON)(jsonValue));
        });
    }
    /**
     * Creates an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create issue type screen scheme
     */
    createIssueTypeScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createIssueTypeScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete issue type screen scheme
     */
    deleteIssueTypeScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeId'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeId', 'Required parameter "issueTypeScreenSchemeId" was null or undefined when calling deleteIssueTypeScreenScheme().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/{issueTypeScreenSchemeId}`.replace(`{${"issueTypeScreenSchemeId"}}`, encodeURIComponent(String(requestParameters['issueTypeScreenSchemeId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Deletes an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete issue type screen scheme
     */
    deleteIssueTypeScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteIssueTypeScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of issue type screen scheme items.  Only issue type screen schemes used in classic projects are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen scheme items
     */
    getIssueTypeScreenSchemeMappingsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['issueTypeScreenSchemeId'] != null) {
                queryParameters['issueTypeScreenSchemeId'] = requestParameters['issueTypeScreenSchemeId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/mapping`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanIssueTypeScreenSchemeItemFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of issue type screen scheme items.  Only issue type screen schemes used in classic projects are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen scheme items
     */
    getIssueTypeScreenSchemeMappings(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIssueTypeScreenSchemeMappingsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of issue type screen schemes and, for each issue type screen scheme, a list of the projects that use it.  Only issue type screen schemes used in classic projects are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen schemes for projects
     */
    getIssueTypeScreenSchemeProjectAssociationsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getIssueTypeScreenSchemeProjectAssociations().');
            }
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['projectId'] != null) {
                queryParameters['projectId'] = requestParameters['projectId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/project`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanIssueTypeScreenSchemesProjectsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of issue type screen schemes and, for each issue type screen scheme, a list of the projects that use it.  Only issue type screen schemes used in classic projects are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen schemes for projects
     */
    getIssueTypeScreenSchemeProjectAssociations(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIssueTypeScreenSchemeProjectAssociationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of issue type screen schemes.  Only issue type screen schemes used in classic projects are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen schemes
     */
    getIssueTypeScreenSchemesRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            if (requestParameters['queryString'] != null) {
                queryParameters['queryString'] = requestParameters['queryString'];
            }
            if (requestParameters['orderBy'] != null) {
                queryParameters['orderBy'] = requestParameters['orderBy'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanIssueTypeScreenSchemeFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of issue type screen schemes.  Only issue type screen schemes used in classic projects are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen schemes
     */
    getIssueTypeScreenSchemes(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIssueTypeScreenSchemesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of projects associated with an issue type screen scheme.  Only company-managed projects associated with an issue type screen scheme are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen scheme projects
     */
    getProjectsForIssueTypeScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeId'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeId', 'Required parameter "issueTypeScreenSchemeId" was null or undefined when calling getProjectsForIssueTypeScreenScheme().');
            }
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['query'] != null) {
                queryParameters['query'] = requestParameters['query'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/{issueTypeScreenSchemeId}/project`.replace(`{${"issueTypeScreenSchemeId"}}`, encodeURIComponent(String(requestParameters['issueTypeScreenSchemeId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanProjectDetailsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of projects associated with an issue type screen scheme.  Only company-managed projects associated with an issue type screen scheme are returned.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get issue type screen scheme projects
     */
    getProjectsForIssueTypeScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectsForIssueTypeScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Removes issue type to screen scheme mappings from an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Remove mappings from issue type screen scheme
     */
    removeMappingsFromIssueTypeScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeId'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeId', 'Required parameter "issueTypeScreenSchemeId" was null or undefined when calling removeMappingsFromIssueTypeScreenScheme().');
            }
            if (requestParameters['issueTypeIds'] == null) {
                throw new runtime.RequiredError('issueTypeIds', 'Required parameter "issueTypeIds" was null or undefined when calling removeMappingsFromIssueTypeScreenScheme().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/{issueTypeScreenSchemeId}/mapping/remove`.replace(`{${"issueTypeScreenSchemeId"}}`, encodeURIComponent(String(requestParameters['issueTypeScreenSchemeId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.IssueTypeIdsToJSON)(requestParameters['issueTypeIds']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Removes issue type to screen scheme mappings from an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Remove mappings from issue type screen scheme
     */
    removeMappingsFromIssueTypeScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.removeMappingsFromIssueTypeScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates the default screen scheme of an issue type screen scheme. The default screen scheme is used for all unmapped issue types.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update issue type screen scheme default screen scheme
     */
    updateDefaultScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeId'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeId', 'Required parameter "issueTypeScreenSchemeId" was null or undefined when calling updateDefaultScreenScheme().');
            }
            if (requestParameters['updateDefaultScreenScheme'] == null) {
                throw new runtime.RequiredError('updateDefaultScreenScheme', 'Required parameter "updateDefaultScreenScheme" was null or undefined when calling updateDefaultScreenScheme().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/{issueTypeScreenSchemeId}/mapping/default`.replace(`{${"issueTypeScreenSchemeId"}}`, encodeURIComponent(String(requestParameters['issueTypeScreenSchemeId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.UpdateDefaultScreenSchemeToJSON)(requestParameters['updateDefaultScreenScheme']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Updates the default screen scheme of an issue type screen scheme. The default screen scheme is used for all unmapped issue types.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update issue type screen scheme default screen scheme
     */
    updateDefaultScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateDefaultScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update issue type screen scheme
     */
    updateIssueTypeScreenSchemeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueTypeScreenSchemeId'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeId', 'Required parameter "issueTypeScreenSchemeId" was null or undefined when calling updateIssueTypeScreenScheme().');
            }
            if (requestParameters['issueTypeScreenSchemeUpdateDetails'] == null) {
                throw new runtime.RequiredError('issueTypeScreenSchemeUpdateDetails', 'Required parameter "issueTypeScreenSchemeUpdateDetails" was null or undefined when calling updateIssueTypeScreenScheme().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issuetypescreenscheme/{issueTypeScreenSchemeId}`.replace(`{${"issueTypeScreenSchemeId"}}`, encodeURIComponent(String(requestParameters['issueTypeScreenSchemeId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.IssueTypeScreenSchemeUpdateDetailsToJSON)(requestParameters['issueTypeScreenSchemeUpdateDetails']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Updates an issue type screen scheme.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update issue type screen scheme
     */
    updateIssueTypeScreenScheme(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateIssueTypeScreenSchemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.IssueTypeScreenSchemesApi = IssueTypeScreenSchemesApi;
/**
 * @export
 */
exports.GetIssueTypeScreenSchemesOrderByEnum = {
    Name: 'name',
    Name2: '-name',
    Name3: '+name',
    Id: 'id',
    Id2: '-id',
    Id3: '+id'
};
//# sourceMappingURL=IssueTypeScreenSchemesApi.js.map